import React, { useState } from 'react';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isAuthorsDropdownOpen, setIsAuthorsDropdownOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [expandedDropdown, setExpandedDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);

  const handleDropdownClick = (dropdownName) => {
    setExpandedDropdown(expandedDropdown === dropdownName ? null : dropdownName);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    // Sidebar açıldığında scroll'u engelle
    document.body.style.overflow = !isSidebarOpen ? 'hidden' : 'auto';
  };

  return (
    <>
      <Navbar bg="akm-red" expand="md" className="py-2">
        <Container>
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="logo-container">
              <Link to="/">
                <img 
                  src="/images/AKM_CDTST_LOGO_TEKLI_6.png" 
                  alt="Cumhurbaşkanlığı Logo" 
                  className="logo-img" 
                />
              </Link>
            </div>
            <div className="akm-logo-container">
              <a href="https://www.akmb.gov.tr" target="_blank" rel="noopener noreferrer">
                <img 
                  src="/images/cdtst/akmbLogo.png" 
                  alt="AKM Logo" 
                  className="akm-logo-img" 
                />
              </a>
            </div>
          </div>
        </Container>
      </Navbar>
      
      <Navbar bg="akm-gray" expand="md" className="py-0">
        <Container className="d-flex">
          <button 
            className="navbar-toggler" 
            type="button" 
            onClick={toggleSidebar}
            aria-controls="navbar-nav"
            aria-expanded={isSidebarOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Desktop Menu */}
          <div className="desktop-menu">
            <Nav className="w-100">
            <Link to="/" className="nav-link text-white px-3 py-2">Anasayfa</Link>
              <Link to="/hakkinda" className="nav-link text-white px-3 py-2">Hakkında</Link>
              
              <NavDropdown 
                title={
                  <>
                    Maddeler
                    <i className="fas fa-chevron-down dropdown-icon"></i>
                  </>
                }
                id="maddeler-dropdown"
                className="custom-dropdown"
                show={isDropdownOpen}
                onMouseEnter={() => setIsDropdownOpen(true)}
                onMouseLeave={() => setIsDropdownOpen(false)}
              >
                <Link to="/maddeler" className="dropdown-item">Tüm Maddeler</Link>
                <Link to="/maddeler?group=A-E" className="dropdown-item dropdown-item-a-e">A-E</Link>
                <Link to="/maddeler?group=F-J" className="dropdown-item dropdown-item-f-j">F-J</Link>
                <Link to="/maddeler?group=K-P" className="dropdown-item dropdown-item-k-p">K-P</Link>
                <Link to="/maddeler?group=R-Z" className="dropdown-item dropdown-item-r-z">R-Z</Link>
                <Link to="/maddeler?group=0-9" className="dropdown-item dropdown-item-0-9">0-9</Link>
              </NavDropdown>
              
              <NavDropdown 
                title={
                  <>
                    Yazarlar
                    <i className="fas fa-chevron-down dropdown-icon"></i>
                  </>
                }
                id="yazarlar-dropdown"
                className="custom-dropdown"
                show={isAuthorsDropdownOpen}
                onMouseEnter={() => setIsAuthorsDropdownOpen(true)}
                onMouseLeave={() => setIsAuthorsDropdownOpen(false)}
              >
                <Link to="/yazarlar" className="dropdown-item">Tüm Yazarlar</Link>
                <Link to="/yazarlar?group=A-E" className="dropdown-item dropdown-item-a-e">A-E</Link>
                <Link to="/yazarlar?group=F-J" className="dropdown-item dropdown-item-f-j">F-J</Link>
                <Link to="/yazarlar?group=K-P" className="dropdown-item dropdown-item-k-p">K-P</Link>
                <Link to="/yazarlar?group=R-Z" className="dropdown-item dropdown-item-r-z">R-Z</Link>
                <Link to="/yazarlar?group=0-9" className="dropdown-item dropdown-item-0-9">0-9</Link>
              </NavDropdown>
              
              <Link to="/gelismisArama" className="nav-link text-white px-3 py-2">Gelişmiş Arama</Link>
              <Link to="/harita" className="nav-link text-white px-3 py-2">Harita</Link>
              <Link to="/iletisim" className="nav-link text-white px-3 py-2">İletişim</Link>
            </Nav>
          </div>

          {/* Mobile Sidebar */}
          <div className={`mobile-sidebar ${isSidebarOpen ? 'open' : ''}`}>
            <div className="sidebar-header">
              <button className="close-button" onClick={toggleSidebar}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="sidebar-logo">
              <img 
                src="/images/AKM_CDTST_LOGO_TEKLI_6.png" 
                alt="CTS Logo" 
                className="sidebar-logo-img"
              />
            </div>
            <div className="sidebar-content">
              <Link to="/hakkinda" className="sidebar-item" onClick={toggleSidebar}>Hakkında</Link>
              
              <div className="sidebar-dropdown">
                <div 
                  className="sidebar-dropdown-header" 
                  onClick={() => handleDropdownClick('articles')}
                >
                  Maddeler
                  <i className={`fas fa-chevron-down ${expandedDropdown === 'articles' ? 'rotate' : ''}`}></i>
                </div>
                <div className={`sidebar-dropdown-content ${expandedDropdown === 'articles' ? 'show' : ''}`}>
                  <Link to="/maddeler" className="sidebar-item" onClick={toggleSidebar}>Tüm Maddeler</Link>
                  <Link to="/maddeler?group=A-E" className="sidebar-item" onClick={toggleSidebar}>A-E</Link>
                  <Link to="/maddeler?group=F-J" className="sidebar-item" onClick={toggleSidebar}>F-J</Link>
                  <Link to="/maddeler?group=K-P" className="sidebar-item" onClick={toggleSidebar}>K-P</Link>
                  <Link to="/maddeler?group=R-Z" className="sidebar-item" onClick={toggleSidebar}>R-Z</Link>
                  <Link to="/maddeler?group=0-9" className="sidebar-item" onClick={toggleSidebar}>0-9</Link>
                </div>
              </div>

              <div className="sidebar-dropdown">
                <div 
                  className="sidebar-dropdown-header" 
                  onClick={() => handleDropdownClick('authors')}
                >
                  Yazarlar
                  <i className={`fas fa-chevron-down ${expandedDropdown === 'authors' ? 'rotate' : ''}`}></i>
                </div>
                <div className={`sidebar-dropdown-content ${expandedDropdown === 'authors' ? 'show' : ''}`}>
                  <Link to="/yazarlar" className="sidebar-item" onClick={toggleSidebar}>Tüm Yazarlar</Link>
                  <Link to="/yazarlar?group=A-E" className="sidebar-item" onClick={toggleSidebar}>A-E</Link>
                  <Link to="/yazarlar?group=F-J" className="sidebar-item" onClick={toggleSidebar}>F-J</Link>
                  <Link to="/yazarlar?group=K-P" className="sidebar-item" onClick={toggleSidebar}>K-P</Link>
                  <Link to="/yazarlar?group=R-Z" className="sidebar-item" onClick={toggleSidebar}>R-Z</Link>
                  <Link to="/yazarlar?group=0-9" className="sidebar-item" onClick={toggleSidebar}>0-9</Link>
                </div>
              </div>
              
              <Link to="/gelismisArama" className="sidebar-item" onClick={toggleSidebar}>Gelişmiş Arama</Link>
              <Link to="/harita" className="sidebar-item" onClick={toggleSidebar}>Harita</Link>
              <Link to="/iletisim" className="sidebar-item" onClick={toggleSidebar}>İletişim</Link>
            </div>
          </div>

          {/* Overlay */}
          {isSidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
        </Container>
      </Navbar>
    </>
  );
};

export default Header; 